"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var SpeisekarteModel_1 = require("../../models/SpeisekarteModel");
var reactstrap_1 = require("reactstrap");
var immutability_helper_1 = require("immutability-helper");
var KopfDialog = /** @class */ (function (_super) {
    __extends(KopfDialog, _super);
    function KopfDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (event, item) {
            console.log(item.key);
            var additional = _this.state.head;
            additional.categorie = item.key;
        };
        _this.doubleClickEvent = function (data) {
            _this.setState({ hideAddDialog: false, addit: data });
        };
        _this.newAdd = function () {
            var newAdd = new SpeisekarteModel_1.Additional();
            newAdd.index = 0;
            _this.setState({ hideAddDialog: false, addit: newAdd });
        };
        _this.addDelete = function () {
            var data = _this.state.head;
            var addIndex = data.additionals.findIndex(function (c) { return c.index === _this.state.addit.index; });
            var newData = immutability_helper_1.default(_this.state.head.additionals, {
                $splice: [[addIndex, 1]]
            });
            data.additionals = newData;
            _this.setState({ head: data, hideAddDialog: true, hideDialog: true });
        };
        _this.addSave = function () {
            if (_this.state.addit.index > 0)
                _this.addUpdate();
            else {
                _this.state.addit.index = Math.max.apply(Math, __spreadArrays(_this.state.head.additionals.map(function (o) { return o.index; }), [0])) + 1;
                _this.addAdd();
            }
        };
        _this.addAdd = function () {
            var data = _this.state.head;
            var addIndex = data.additionals.length;
            var newData = immutability_helper_1.default(_this.state.head.additionals, {
                $splice: [[addIndex, 1, _this.state.addit]]
            });
            data.additionals = newData;
            _this.setState({ head: data, hideAddDialog: true, hideDialog: true });
        };
        _this.addUpdate = function () {
            var data = _this.state.head;
            var addIndex = data.additionals.findIndex(function (c) { return c.index === _this.state.addit.index; });
            var newData = immutability_helper_1.default(_this.state.head.additionals, {
                $splice: [[addIndex, 1, _this.state.addit]]
            });
            data.additionals = newData;
            _this.setState({ head: data, hideAddDialog: true, hideDialog: true });
        };
        _this.nameAddChanged = function (event, newValue) {
            var additional = _this.state.addit;
            additional.value = newValue;
        };
        _this.priceAddChanged = function (event, newValue) {
            var additional = _this.state.addit;
            additional.price = newValue;
        };
        _this.nameChanged = function (event, newValue) {
            var additional = _this.state.head;
            additional.value = newValue;
        };
        _this.additionalChanged = function (event, newValue) {
            var additional = _this.state.head;
            additional.additionalValue = newValue;
        };
        _this.subTextChanged = function (event, newValue) {
            var additional = _this.state.head;
            additional.subText = newValue;
        };
        _this.onRenderFooterContent = function () { return (React.createElement("div", { style: { minWidth: '200px', maxWidth: '600px' } },
            React.createElement(office_ui_fabric_react_1.Stack, { tokens: { childrenGap: 20 }, horizontal: true },
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "start", grow: true },
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { className: "ms-Cancel-Button", onClick: function () { return _this.confirmDialog(null); }, text: "Zur\u00FCck ohne speichern", primaryDisabled: false })),
                React.createElement(office_ui_fabric_react_1.Stack.Item, { align: "end", grow: true, styles: { root: { alignContent: "flex-end", flexGrow: 0 } } },
                    React.createElement(office_ui_fabric_react_1.PrimaryButton, { className: "ms-Default-Button2", onClick: function () { _this.confirmDialog(_this.state.head); }, text: "Speichern" }))))); };
        _this.updateData = function (data) {
            _this.setState({ head: data, hideDialog: true });
        };
        _this.closeDialog = function () {
            _this.setState({ hideDialog: false });
        };
        _this.confirmDialog = function (head) {
            _this.props.confirmedEvent(head);
        };
        _this.state = {
            hideDialog: false, head: new SpeisekarteModel_1.SmallHeadline(), addit: new SpeisekarteModel_1.Additional(), hideAddDialog: true
        };
        return _this;
    }
    KopfDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(office_ui_fabric_react_1.Panel, { isOpen: this.state.hideDialog, onDismiss: function () { return _this.confirmDialog(null); }, type: office_ui_fabric_react_1.PanelType.custom, customWidth: "500px", onRenderFooterContent: this.onRenderFooterContent, isFooterAtBottom: true, headerText: this.state.head.value !== null ? this.state.head.value + " bearbeiten" : "Neue Kopfzeile anlegen" },
                React.createElement("div", { style: { minWidth: "200px", maxWidth: "600px" } },
                    React.createElement("div", { style: { paddingLeft: "20px", paddingRight: "20px", paddingBottom: "20px", marginTop: "20px" } },
                        React.createElement(office_ui_fabric_react_1.TextField, { label: "Name", required: true, defaultValue: this.state.head.value, onChange: this.nameChanged }),
                        React.createElement(Dropdown_1.Dropdown, { label: "Kategorie", defaultSelectedKey: this.state.head.categorie, onChange: this.onChange, options: [{ key: "Speise", text: "Speise" }, { key: "Getränke", text: "Getränke" }, { key: "Sonder", text: "Sonder" }] }),
                        React.createElement(office_ui_fabric_react_1.TextField, { label: "Zusatztext", defaultValue: this.state.head.additionalValue, onChange: this.additionalChanged }),
                        React.createElement(office_ui_fabric_react_1.TextField, { label: "Absatz", multiline: true, rows: 15, required: true, defaultValue: this.state.head.subText, onChange: this.subTextChanged }),
                        React.createElement(reactstrap_1.Container, { style: { marginTop: "15px", marginBottom: "15px" } },
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, { style: { paddingLeft: "0px" } },
                                    React.createElement("div", { style: { display: "flex" } },
                                        React.createElement("div", { style: { fontSize: "20px", fontWeight: 600 } }, "Extrazutaten"),
                                        React.createElement("div", { style: { position: "absolute", display: "flex", right: "15px", fontSize: "20px", fontWeight: 600 } },
                                            React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Neu", ariaLabel: "Neu", onClick: this.newAdd }))))),
                            React.createElement(reactstrap_1.Row, null,
                                React.createElement(reactstrap_1.Col, null, this.state.head.additionals !== undefined && this.state.head.additionals !== null && this.state.head.additionals.map(function (additional, num) {
                                    return (React.createElement("div", { style: { width: "100%", display: "flex" }, onDoubleClick: function () { return _this.doubleClickEvent(additional); } },
                                        React.createElement("div", { style: { width: "85%" } }, additional.value),
                                        React.createElement("div", { style: { position: "absolute", display: "flex", right: "15px" } }, additional.price)));
                                }))))))),
            React.createElement(office_ui_fabric_react_1.Dialog, { hidden: this.state.hideAddDialog, onDismiss: function () { }, dialogContentProps: {
                    type: office_ui_fabric_react_1.DialogType.normal,
                    title: 'Extras'
                }, modalProps: {
                    isBlocking: true,
                    styles: { main: { maxWidth: 6000 } }
                } },
                React.createElement(office_ui_fabric_react_1.TextField, { label: "Name", defaultValue: this.state.addit.value, required: true, onChange: this.nameAddChanged }),
                React.createElement(office_ui_fabric_react_1.TextField, { label: "Preis", defaultValue: this.state.addit.price, required: true, onChange: this.priceAddChanged }),
                React.createElement(office_ui_fabric_react_1.DialogFooter, null,
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: this.addDelete, text: "L\u00F6schen" }),
                    React.createElement(office_ui_fabric_react_1.PrimaryButton, { onClick: this.addSave, text: "Speichern" })))));
    };
    return KopfDialog;
}(React.Component));
exports.default = KopfDialog;
//# sourceMappingURL=NeuerKopf.js.map